import { Component } from '@angular/core';

@Component({
  selector: 'app-spinner-white',
  standalone: true,
  imports: [],
  templateUrl: './spinner-white.component.html',
  styles: ``
})
export class SpinnerWhiteComponent {

}
